import { useEffect, useState } from "react";
import { Layout, SectionTitle } from "@/components/Layout";
import { AppCard } from "@/components/cards";
import { api } from "@/lib/api";

const FILTERS = ["Todos", "Android", "TV Box", "Smart TV", "Samsung", "LG", "iOS", "Windows", "Fire TV"];

export default function AppsPage() {
  const [apps, setApps] = useState([]);
  const [filter, setFilter] = useState("Todos");
  useEffect(() => { api.get("/apps").then((r) => setApps(r.data)); }, []);

  const filtered = filter === "Todos" ? apps :
    apps.filter((a) => a.platforms.some((p) => p.toLowerCase().includes(filter.toLowerCase())));

  return (
    <Layout>
      <div className="max-w-7xl mx-auto px-4 sm:px-8 py-14">
        <SectionTitle label="Aplicativos" title="Aplicativos Recomendados"
          subtitle="Organizados por sistema. Filtre para encontrar o app ideal para seu dispositivo." />
        <div className="flex flex-wrap gap-2 mb-8">
          {FILTERS.map((f) => (
            <button key={f} onClick={() => setFilter(f)} data-testid={`app-filter-${f.toLowerCase().replace(/\s+/g,'-')}`}
              className={`px-4 py-2 rounded-full text-sm font-medium border transition ${
                filter === f ? "bg-cyan-400/15 text-cyan-300 border-cyan-400/40" : "bg-white/5 text-gray-300 border-white/10 hover:bg-white/10"}`}>
              {f}
            </button>
          ))}
        </div>
        <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {filtered.map((a) => <AppCard key={a.id} app={a} />)}
        </div>
        {filtered.length === 0 && <div className="text-gray-400 text-center py-10">Nenhum aplicativo nesta categoria.</div>}
      </div>
    </Layout>
  );
}
